import { Injectable } from '@angular/core';

export type ReportMeasurementResult = {result: {length: string, area: string, objectDistance?: string}, mode: string, unit: string, id: string}

@Injectable({ providedIn: 'root' })
export class LegacyReportMeasurementService {

  public toReportMeasurementResult(measurement: any): ReportMeasurementResult[] {
    if (measurement === null) {
    return null;
    }

    const result: ReportMeasurementResult[] = [];
    measurement.forEach(item => {
    if (item.type === 'image') {
        return;
    }
    if (result.some(_ => _.id == item.data.id)) {
        return;
    }

    result.push(this.convertData(item?.data));
    });

    return result;
  }

  private convertData(data: any) {
    const MAX_ObjectDistance = 10000;
    const MAX_MM = 100000;
    const MAX_INCH = 10000;
    const MAX_AREA_MM = 100000000;
    const MAX_AREA_INCH = 1000000;
    const INCH_SCALE = 25.4;

    const copied = JSON.parse(JSON.stringify(data));

    let distance = Number(copied?.result?.objectDistance);
    let length = Number(copied?.result?.length);
    let area = Number(copied?.result?.area);
    switch (copied?.unit) {
      case 'mm':
      default:
        if (copied.mode != 'Area') {
          if (length >= MAX_MM) {
            copied.result.length = 'OVER';
          }
          else {
            copied.result.length = this.setFractionDigits(length.toPrecision(3), 2);
          }
        }
        else {
          if (area < 0) {
            copied.result.area = 'WRONG FIGURE';
          }
          else if (area >= MAX_AREA_MM) {
            copied.result.area = 'OVER';
          }
          else {
            copied.result.area = this.setFractionDigits(area.toPrecision(3), 2);
          }
        }

        if (distance >= MAX_ObjectDistance) {
          copied.result.objectDistance = '-----';
        }
        else {
          copied.result.objectDistance = this.setFractionDigits(distance.toPrecision(3), 2);
        }
        break;
      case 'inch':
        distance /= INCH_SCALE;
        length /= INCH_SCALE;
        area /= INCH_SCALE;

        if (copied.mode != 'Area') {
          if (length >= MAX_INCH) {
            copied.result.length = 'OVER';
          }
          else {
            copied.result.length = this.setFractionDigits(length.toPrecision(4), 3);
          }
        }
        else {
          if (area < 0) {
            copied.result.area = 'WRONG FIGURE';
          }
          else if (area >= MAX_AREA_INCH) {
            copied.result.area = 'OVER';
          }
          else {
            copied.result.area = this.setFractionDigits(area.toPrecision(4), 3);
          }
        }

        if (distance >= MAX_ObjectDistance) {
          copied.result.objectDistance = '-----';
        }
        else {
          copied.result.objectDistance = this.setFractionDigits(distance.toPrecision(4), 3);
        }
        break;
    }

    return copied;
  }

  private setFractionDigits(result: string, fractionDigits: number) {
    return Number(result).toFixed(fractionDigits);
  }

}
